import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import { getToken } from '@/utils/auth'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  //    baseURL: 'http://localhost:8087',
      baseURL: 'http://120.41.36.55:18087',
  //  baseURL: '/prod-api',
  // 超时
  timeout: 120000
})
// request拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
  },
  error => {
    //  console.log(error.response.data)
    Promise.reject(error.response.data)
  }
)

// 响应拦截器
service.interceptors.response.use(res => {
  const code = res.data.code
  if (code === 401) {
    MessageBox.confirm(
      '登录状态已过期，您可以继续留在该页面，或者重新登录',
      '系统提示',
      {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }
    ).then(() => {
     
    })
  } else if (code != 200) {
    Message({
      message: res.data.msg,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(res.data)
  } else {
    return res.data
  }

},
  error => {
    if (error.response != undefined) {
      if (error.response.status === 500) {
        Message({
          message: error.response.data.msg,
          type: 'error',
          duration: 5 * 1000
        })
      }
      console.log(error.response.data)
      return Promise.reject(error.response.data)
    } else {
      console.log(error)
      if( error.message.indexOf("timeout") >= 0)
      {
        Message({
          message: "连接后台网关超时，请检查网关服务或网络连接！",
          type: 'error',
          duration: 5 * 1000
        })
      }
      if(error.message.indexOf("Network Error") >= 0)
      {
        Message({
          message: "连接后台网关网络不通，请检查网关服务或网络连接！",
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(error)
    }

  }
)

export default service
